import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import { ArrowDown01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import OrderItemsSummary from "@/components/OrderDetails/components/OrderItemsSummary";
import { useResponsive } from "@/hooks";
import OrderStatusLayout from "./OrderStatusLayout";
import StatusView from "./StatusView";
import PostOrderSurveyCard from "./PostOrderSurveyCard";
import { OrderStatusViewProps } from "./OrderStatusDesktop";

const OrderStatusMobile: React.FC<OrderStatusViewProps> = ({
  order,
  orderNumber,
  isCompleted,
  organizationId,
  surveyId,
  subtotalValue,
  deliveryValue,
  taxesValue,
  totalValue,
  onGoBack,
}) => {
  const { isMobile } = useResponsive();
  const [isOrderDetailsExpanded, setIsOrderDetailsExpanded] = useState(false);

  return (
    <Stack height="100%" flex={1}>
      <OrderStatusLayout orderNumber={order?.number ?? orderNumber} order={order}>
        <Stack flex={1} spacing={2}>
          <StatusView order={order} isCompleted={isCompleted} />

          {isCompleted && (
            <PostOrderSurveyCard
              organizationId={organizationId}
              surveyId={surveyId}
              order={order}
            />
          )}

          <Accordion
            expanded={isOrderDetailsExpanded}
            onChange={(_, expanded) => setIsOrderDetailsExpanded(expanded)}
            elevation={0}
            sx={{
              borderRadius: "12px !important",
              border: "1px solid",
              borderColor: "divider",
              backgroundColor: "#fff",
              "&::before": { display: "none" },
            }}
          >
            <AccordionSummary expandIcon={<HugeiconsIcon icon={ArrowDown01Icon} />}>
              <Typography fontWeight={500}>Pedido</Typography>
            </AccordionSummary>

            <Divider />

            <AccordionDetails>
              <OrderItemsSummary
                order={order}
                subtotal={subtotalValue}
                deliveryValue={deliveryValue}
                taxesValue={taxesValue}
                total={totalValue}
                isMobile={isMobile}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    border: "none",
                  },
                }}
              />
            </AccordionDetails>
          </Accordion>

          {isCompleted && (
            <Button
              variant="contained"
              color="primary"
              size="large"
              fullWidth
              onClick={onGoBack}
              sx={{
                backgroundColor: "#015FEE",
                "&:hover": {
                  backgroundColor: "#014ecc",
                },
              }}
            >
              Regresar
            </Button>
          )}
        </Stack>
      </OrderStatusLayout>
    </Stack>
  );
};

export default OrderStatusMobile;
